import React from "react";
import Header from "./Header";
import { Link } from "react-router-dom";

const Home: React.FC = () => {
  return (
    <>
      <h1>Home</h1>
      <Header />
      <p>
        Go to the <Link to="/about">About</Link> page.
      </p>
    </>
  )
};

export default Home;